
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    bankListing:[],
    bankDetail:null
  };
  
  const bankReducer = (state = initialState, action) => {
    // console.log("bank  reducers------", state,action);
   switch (action.type) {
     case "ADD_BANK_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_BANK_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_BANK_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_BANK_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_BANK_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_BANK_REQUEST_SUCCESS":
        return {
          ...state,
          bankListing: action.payload,
          loading:false,
        };

      case "GOT_BANK_DETAIL":  
      return {
        ...state,
        bankDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default bankReducer;
  